import React from "react";
import { useLanguage } from "../context/LanguageContext";
import festivalLogo from "../img/festival_logo.png";
import "../styles/BannerEditorial.css";

const BannerFestival = () => {
  const { language } = useLanguage();

  const handleClick = () => {
    window.open("https://empordawineandfood.com/", "_blank");
  };

  return (
    <div
      className="banner-editorial"
      onClick={handleClick}
      style={{ backgroundColor: "#EDE7E4" }}
    >
      {/* Contenido del banner */}
      <div className="banner-content">
        <img
          src={festivalLogo}
          alt="Festival Logo"
          className="magazine-logo"
          style={{ width: "720px", maxWidth: "90%" }}
        />
        <p className="banner-text">
          {language === "ES"
            ? "Descubre el Empordà Wine & Food Festival 2025"
            : "Descobreix l’Empordà Wine & Food Festival 2025"}
        </p>
      </div>
    </div>
  );
};

export default BannerFestival;
